import { isEqual } from 'lodash';
import { type Editor } from '@meitu/saas-editor-core';
import { type ITextLayerProps, type ITextMark } from '@meitu/saas-editor-core/es/version-types';
import { useListenActivePickLayerProps } from '@/hooks/use-listen-layer-props';

export const useTextMark = (editor: Editor) => {
    const props = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;

        const layerData = layer.data as ITextLayerProps;
        const { textMark, textContents = [] } = layerData;

        return {
            textMark,
            textContents,
        };
    });

    const textMark = props ? props.textMark : null;
    const textContents = props ? props.textContents : [];

    // 去重过后的数据
    const textMarksInTextContents = (() => {
        const ret: ITextMark[] = [];
        textContents.forEach((item) => {
            const mark = item.textMark;
            if (!mark) return;

            const exist = ret.some((item) => isEqual(mark, item));
            if (!exist) {
                ret.push(mark);
            }
        });
        return ret;
    })();

    const hasNoTextMark = textMark == null && textMarksInTextContents.length === 0;

    const hasMultipleTextMarks = (() => {
        if (!textMark) return textMarksInTextContents.length > 1;
        if (textMarksInTextContents.length === 0) return false;
        if (textMarksInTextContents.length === 1) {
            return !isEqual(textMark, textMarksInTextContents[0]);
        }
        return true;
    })();

    return {
        textMarksInTextContents,
        textMark,
        hasNoTextMark,
        hasMultipleTextMarks,
    };
};
